/**
 * Uproszczony moduł obsługi wysyłki
 */

// Obsługa błędu appendChild (ten błąd pojawia się w niektórych pluginach WooCommerce)
window.addEventListener('error', function(event) {
    if (event.error && event.error.message && event.error.message.indexOf('appendChild is not a function') >= 0) {
        event.preventDefault();
        return true;
    }
}, true);

// Inicjalizacja podstawowych funkcji dla metod wysyłki
document.addEventListener('DOMContentLoaded', function() {
    // Obsługa zmiany metody wysyłki
    jQuery(document).on('change', 'input[name^="shipping_method"]', function() {
        // Pobierz wybraną metodę
        var selectedMethod = jQuery(this).val();
        
        // Sprawdź czy metoda wymaga dodatkowych informacji
        var requiresAdditionalInfo = false;
        var label = jQuery(this).closest('li').find('label').text().toLowerCase();
        
        if (label.indexOf('punkt odbioru') >= 0 || 
            label.indexOf('paczkomat') >= 0 || 
            label.indexOf('pickup') >= 0) {
            requiresAdditionalInfo = true;
        }
        
        // Jeśli metoda nie wymaga dodatkowych informacji, wyczyść pola
        if (requiresAdditionalInfo === false) {
            // Wyczyść wszystkie ukryte pola punktów odbioru
            jQuery('input[type="hidden"][name*="point"], input[type="hidden"][name*="paczkomat"]').val('');
            
            // Aktualizuj formularz
            jQuery('body').trigger('update_checkout');
        }
    });
    
    // Sprawdzanie poprawności wyboru metody wysyłki przed złożeniem zamówienia
    jQuery('form.checkout').on('checkout_place_order', function() {
        // Kod podstawowej walidacji - sprawdza tylko czy wybrano metodę wysyłki
        var selectedMethod = jQuery('input[name^="shipping_method"]:checked').val();
        if (selectedMethod === undefined || selectedMethod === null || selectedMethod === '') {
            alert('Proszę wybrać metodę wysyłki przed złożeniem zamówienia.');
            return false;
        }
        return true;
    });
});
